import script from "./FancyMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FancyMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./FancyMultiSelect.vue?vue&type=style&index=0&id=6705ced5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6705ced5"]])

export default __exports__